import { render } from "./CodeIframe.vue?vue&type=template&id=054a66b7"
import script from "./CodeIframe.vue?vue&type=script&lang=js"
export * from "./CodeIframe.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__